
import { ref } from "vue";
import { Options, Vue } from "vue-class-component";
import { Inject, Watch } from "vue-property-decorator";
import HelpScreen from '../help-screen/index.vue';

import { CommitteeView } from "@/modules/typescript-cmpApi-client/models";
import store from "@/store";
import { CMPApi } from "@/modules/cmp-api";
import { AppInsights } from "@/appInsights";
import { EventEmitter } from "events";
import HelpText from '../../assets/config/help-text.json';
import { orderBy } from "lodash";
import FullScreenFileViewer from '../full-screen-file-viewer/index.vue';

@Options({
  components: {
    HelpScreen,
    FullScreenFileViewer,
  }
})
export default class GeneralFiles extends Vue {

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;

  private fileSource = '';
  private iframeRef = ref<HTMLElement | null>();
  private fileId = '';
  private committeeId = '';
  private activeTab = 1;
  private isSubmitting = false;

  private showHelpScreen = false;

  private meetingNote = '';

  private generalFiles: any = [];

  private myCommittees: CommitteeView[] = [];
  private currentCommittee: CommitteeView = {};
  private currentFile = {};

  private showFullScreenFileViewer = false;

  get pageHeader(): string {
    return HelpText[0].generalFileViewer.pageHeading;
  }

  get pageDescription(): string {
    return HelpText[0].generalFileViewer.pageDescription;
  }

  get pageSection(): any[] {
    return HelpText[0].generalFileViewer.section;
  }

  @Watch('$route')
  public OnRouteChange(val: any, oldVal: any): void {
    // console.log('route from: ', oldVal);
    // console.log('route to: ', val);

    this.fileId = this.$route.query.fileId as string;
    // if (val.path !== '/') {
    //   this.getFile(parseInt(this.fileId));
    // }

  }

  mounted() {
    this.committeeId = this.$route.query.committeeId as string
    this.fileId = this.$route.query.fileId as string;
    this.getMyCommittees();
  }

  private getMyCommittees() {
    this.myCommittees = store.getters.getMyCommittees;
    if (this.myCommittees == null) {
      // console.log('myCommittees is null');
      this.apiService.memberApi?.apiV1MemberGetMyCommitteesGet()
        .then((res: any) => {
          this.myCommittees = res.data.data;
          store.dispatch('setMyCommittees', this.myCommittees);
          this.setCurrentFile();
          this.eventCtrl.emit('isLoadingData', false);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My Committee info: ' + err.response.status);
          this.ai.trackException('Error getting EOI committee info: ' + err);
          this.eventCtrl.emit('isLoadingData', false);
        })
    } else {
      this.setCurrentFile();
    }

  }

  private setCurrentFile() {
    const _thisCommittee = this.myCommittees.filter((c) => {
      return c.id == parseInt(this.committeeId);
    })
    this.currentCommittee = _thisCommittee[0];
    const _thisFiles = this.currentCommittee.files.filter((f: any) => {
      return f.id == parseInt(this.fileId);
    })
    this.currentFile = _thisFiles[0];
    this.getFiles();
    if (this.currentFile !== undefined) {
      this.openFile(this.currentFile);
    } else {
      this.fileId = '-1';
      this.errorOpenFile();
    }
  }

  private errorOpenFile() {
    const ifr = document.getElementById('refDocViewer') as HTMLIFrameElement;
    this.$router.push({ query: { 'fileId': this.fileId, 'committeeId': this.currentCommittee.id } });
    ifr.contentWindow?.location.replace('/no-file-selected');
  }

  private getFile(fileId: number) {
    const ifr = document.getElementById('refDocViewer') as HTMLIFrameElement;
    this.$router.push({ query: { 'fileId': fileId, 'committeeId': this.committeeId } });
    if (fileId > -1) {
      ifr.contentWindow?.location.replace('/App/Viewer?fileId=' + fileId);
    } else {
      ifr.contentWindow?.location.replace('');
    }
  }

  private openFile(file: any) {
    this.currentFile = file;
    const ifr = document.getElementById('refDocViewer') as HTMLIFrameElement;
    this.$router.push({ query: { 'fileId': file.id, 'committeeId': this.currentCommittee.id } });
    ifr.contentWindow?.location.replace('/App/Viewer?fileId=' + file.id);
  }

  private getFiles() {
    // get all files into this.fileList
    const _allFiles = this.currentCommittee.files || [];

    this.generalFiles = _allFiles.filter((file: any) => {
      return file.fileTypeName == 'General';
    });

    this.generalFiles = orderBy(
      this.generalFiles,
      ['createdOn'],
      ['desc']
    );

  }


  private openFullscreen(file: any) {
    this.fileSource = '/App/Viewer?fileId=' + file.id;
    this.showFullScreenFileViewer = true;
  }

}

